import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './main/home/home.component';
import {LoginComponent} from './auth/login/login.component';

const routes: Routes = [
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {
    path: '', canActivateChild: [], children: [
      {path: 'home', component: HomeComponent},
      {
        path: 'audit',
        loadChildren: './audit/audit.module#AuditModule',
      },
      {
        path: 'admin',
        loadChildren: './admin/admin.module#AdminModule',
      },
      {
        path: 'sid',
        loadChildren: './sid/sid.module#SidModule',
      },
    ],
  },
  {path: 'login', component: LoginComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
